import { render, staticRenderFns } from "./agent-info.vue?vue&type=template&id=b2c2b7e2&scoped=true"
import script from "./agent-info.vue?vue&type=script&lang=js"
export * from "./agent-info.vue?vue&type=script&lang=js"
import style0 from "./agent-info.vue?vue&type=style&index=0&id=b2c2b7e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c2b7e2",
  null
  
)

export default component.exports